import React from 'react';
import { Alert, Button, Modal, connectModal } from '@gsa/afp-component-library';
import './areq-afv-info-modal.scss';
export function AreqAfvInfoModal({
                               handleClose,
                               handleContinue,
                               availableAfvFunds,
                             }) {
  return (
    <Modal
      className=""
      onClose={handleClose}
      actions={
        <div
          style={{
            display: 'flex',
            gap: '10px',
          }}
        >
          <Button
            type="button"
            variant="unstyled"
            onClick={handleClose}
            label="Close"
          />
          <Button
            type="button"
            variant="primary"
            onClick={handleContinue}
            label="Proceed"
          />
        </div>
      }
      variant='large'
      title={
        <Alert type="info">
        {'The AFV funding amount required to order the low bid model with option AREQ is not available'}
        </Alert>
      }
    >
        <div className="areq-afv-modal-desc">
          The AFV funding amount required to order the low bid model with option AREQ is not available.
          The final amount of required AFV funding may be different based on the awarded quote.
          The selected customer has ${availableAfvFunds} of AFV funding available. You may proceed with the requisition at this time.
          Please contact your Zonal Acquisition Coordinator for more information, and to ensure that the customer will have
          sufficient AFV funding at the time of order.
        </div>

    </Modal>
  );
}

export default connectModal(AreqAfvInfoModal);
